import { QuestionType, QuestionTypeApi } from '@stormwater-software/lib-inspection-templates';
import xhrService from '../api';

export interface NewQuestionType {
  label: string;
  controlTypes: string[];
  isSystem?: boolean;
}

export const questionTypeApi: QuestionTypeApi & {
  create: (data: NewQuestionType) => Promise<QuestionType>;
} = {
  index: () => {
    return xhrService
      .get(`/api/question-types`)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },

  create: (data) => {
    return xhrService
      .post(`/api/question-types`, data)
      .then((res) => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },
};
